import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { Shell } from '@app/shell/shell.service';
import { ShellComponent } from './shell/shell.component';
import { NotAlowedComponent } from './auth/noAlowed/not-alowed/not-alowed.component';
import { MaintenanceGuard } from './guards/maintenance.guard';

const routes: Routes = [
  {
    path: 'legal',
    loadChildren: () => import('./legal/legal.module').then((m) => m.LegalModule),
  },
  {
    path: '',
    redirectTo: '/home',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [MaintenanceGuard],
    children: [
      // Home usa shell pero sin autenticación
      {
        path: 'home',
        component: ShellComponent,
        children: [{ path: '', loadChildren: () => import('./home/home.module').then((m) => m.HomeModule) }],
      },
      Shell.childRoutes([
        { path: 'about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
        {
          path: 'games',
          loadChildren: () => import('./games-directory/games-directory.module').then((m) => m.GamesDirectoryModule),
        },
        { path: 'account', loadChildren: () => import('./account/account.module').then((m) => m.AccountModule) },
        { path: 'payment', loadChildren: () => import('./payment/payment.module').then((m) => m.PaymentModule) },
        {
          path: 'purchase-history',
          loadChildren: () => import('./history/history.module').then((m) => m.HistoryModule),
        },
        { path: 'game', loadChildren: () => import('./game/game.module').then((m) => m.GameModule) },
        {
          path: 'results',
          loadChildren: () => import('./results-games/results-game.module').then((m) => m.ResultsGameModule),
        },
        {
          path: 'wallet',
          loadChildren: () =>
            import('./wallet/wallet.module').then((m) => {
              const mod = m.WalletModule;
              if (!mod) {
                console.error('WalletModule failed to load. Chunk may be missing or corrupted.');
                throw new Error('WalletModule failed to load');
              }
              return mod;
            }),
        },
        { path: 'casino', loadChildren: () => import('./casino/casino.module').then((m) => m.CasinoModule) },
        { path: 'book', loadChildren: () => import('./book/book.module').then((m) => m.BookModule) },
        { path: 'no-allowed', component: NotAlowedComponent },
      ]),
    ],
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule],
  providers: [],
})
export class AppRoutingModule {}
